import {
  Breadcrumbs,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Structure from '../Structure';
import { Link, useParams } from 'react-router-dom';
import { Link as Enlace } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import data from '../../lib/backend/data';
import toast from 'react-hot-toast';
import { cerrarSesion } from '../../redux/actions/session';
import CamposObligatoriosLeyenda from '../../subcomponents/general/formularios/campos_requeridos_leyenda';

const OpcionCreate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [opcion, setOpcion] = useState({});
  const sesion = useSelector((state) => state.miusuario);

  const handleChange = (e) => {
    const { name, value } = e.target;
    opcion[name] = value;
    return setOpcion({ ...{}, ...opcion });
  };

  const crearOpcion = async () => {
    const requeridos = [
      { value: 'titulo', label: 'Titulo' },
      { value: 'tipo', label: 'tipo' },
    ];
    let faltantes = [];
    requeridos.map((campo) => {
      if (!opcion[campo.value]) faltantes.push(campo.label);
      return true;
    });
    if (faltantes.length > 0)
      return toast.error(`Faltan campos: ${faltantes.join(', ')}`);

    setLoading(true);
    return fetch(`${data.urlapi}/calificaciones/opciones`, {
      method: 'POST',
      body: JSON.stringify(opcion),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos');
          return setLoading(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoading(false);
        } else if (res._id) {
          toast.success('Creado exitosamente');
          setTimeout(() => {
            return (window.location = `/calificaciones/opciones-${res._id}`);
          }, 500);
        }
        return setLoading(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoading(false);
      });
  };

  const render = () => {
    return (
      <div>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link to='/calificaciones/opciones'>Calificaciones-Opciones</Link>
          <Enlace underline='hover' color='text.primary'>
            Crear Calificaciones-Opciones
          </Enlace>
        </Breadcrumbs>
        <h1 style={{ margin: 0 }}>Crear Calificaciones-Opciones</h1>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item md={12} xs={12}>
            <Typography variant='h6'>Datos</Typography>
            <CamposObligatoriosLeyenda />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              label='Titulo'
              variant='filled'
              name='titulo'
              required
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <FormControl fullWidth className='mb-3'>
              <InputLabel required>Tipo</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                label='Tipo'
                name='tipo'
                onChange={handleChange}
                defaultValue={opcion.tipo}
              >
                <MenuItem value='conductor'>Conductor</MenuItem>
                <MenuItem value='cliente'>Cliente</MenuItem>
                <MenuItem value='vehiculo'>Vehículo</MenuItem>
                <MenuItem value='proveedor'>Proveedor</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={12} xs={12}>
            {loading === true ? (
              <CircularProgress />
            ) : (
              <Button
                variant='contained'
                xs={{ m: 0 }}
                onClick={() => crearOpcion()}
              >
                CREAR
              </Button>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  return <Structure component={render()} />;
};

export default OpcionCreate;
